import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
];

const router = createRouter({
    routes,
    history: createWebHashHistory()
})

export default router;